export const types = {
    cambiarCadenas: '[Lang] Cargar cadenas',
    cambiarIdiomas: '[Lang] Cambiar idiomas',
    cambiarIdiomaSeleccionado: '[Lang] Cambiar idioma seleccionado', 

    guardarDatosGenerales: '[App] Guardar datos generales', 
}